import { toCertificationDatePayload } from "./dates";

export function buildCertificationMetadataPayload(
  form: any,
  userInfo: { id?: string } | undefined
): Record<string, unknown> {
  return {
    primer: form.primer,
    certificationAttemptsRequired: form.certificationAttemptsRequired,
    certificationAttemptsAllowed: form.certificationAttemptsAllowed,
    certificationName: form.certificationName,
    regionId: form.regionId,
    territoryId: form.territoryId,
    productName: form.productName,
    scoringMethod: form.scoringMethod,
    code: form.code,
    cohort: "",
    isProductBased: form.isProductBased === 1,
    isLocationBased: form.isLocationBased === 1,
    isActive: form.isActive === 1,
    createdBy: userInfo?.id,
    autoAssign: false,
    territories: [],
    cohorts: [],
    regions: [],
    zones: [],
    salesAidFile: form.salesAidFile ? Number(form.salesAidFile) : null,
    assignToAll: false,
    certificationStartDate: toCertificationDatePayload(form.certificationStartDate),
    certificationDueDate: toCertificationDatePayload(form.certificationDueDate),
  };
}
